import React, { Component } from 'react';
import Dico from '../../helpers/Dico'
import ButtonListRange from '../std/ButtonListRange';
import SliderCriteria from '../std/SliderCriteria';

class DurationSelector extends Component {

    getMessage(i18nKey) { return Dico.getMessage(this.props.context.countryCode, this.props.context.languageCode, i18nKey) }

    handleDurationChange = value => {
        value *= 1.0;
        this.props.onChange(value, this.props.settings);
    }

    render() {
        const durations = this.props.contextCriteria.durationsFiltered;
        return (
            durations &&
            <div className="row shadow-sm rounded m-auto">
                <h5 className="text-secondary">{this.getMessage('calculatorPage.criteria.duration')}</h5>
                {durations.values && durations.values.length < 7 && <ButtonListRange
                    value={this.props.parameters.duration}
                    min={durations.min}
                    max={durations.max}
                    step={durations.step}
                    values={durations.values}
                    onChange={this.handleDurationChange}
                    i18nKey='calculatorPage.criteria.value.duration'
                    i18nArgType='integer'
                    contextMin={this.props.contextCriteria.durMinSvc}
                    contextMax={this.props.contextCriteria.durMaxSvc}
                />}
                {(!durations.values || durations.values.length >= 7) &&
                    <SliderCriteria
                        value={this.props.parameters.duration}
                        min={durations.min}
                        max={durations.max}
                        step={durations.step}
                        values={durations.values}
                        i18nKey='calculatorPage.criteria.value.duration'
                        i18nArgType='integer'
                        onChange={this.handleDurationChange}
                        contextMin={this.props.contextCriteria.durMinSvc}
                        contextMax={this.props.contextCriteria.durMaxSvc}
                    />}
            </div>
        );
    }
}
export default (DurationSelector)
